export default "__VITE_ASSET__Gq$8lJMP__"